import { Card, Flex } from "antd";

import { EngineeringProjects } from "projects/components";
import { IEngineeringProjects } from "projects/models";
import variables from "../../../../../_variables.scss";

type Props = {
  loading?: boolean;
  engineeringProjects?: IEngineeringProjects;
};

export const EngineerDashboardProjectsCard = ({
  loading,
  engineeringProjects,
}: Props) => {
  return (
    <Card
      loading={loading}
      bordered={false}
      data-testid='engineerDashboardProjectsCard'
    >
      <Flex vertical gap={variables.gap}>
        <h1>Projects</h1>
        <EngineeringProjects engineeringProjects={engineeringProjects ?? { projectsInAuditingStage: 0, projectsInEngineeringPrepStage: 0, projectsInEngineeringStage: 0 }} />
      </Flex>
    </Card>
  );
};
